import Component from "@lib/Component.js";
import { addEvent, addClass, removeClass } from "@qneyraud/q-utils";

export default class SearchInput extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  bindMethods() {
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    addEvent(this.refs.input, "focus", this.onInputFocus);
    addEvent(this.refs.input, "blur", this.onInputBlur);
    addEvent(this.refs.button, "click", this.onButtonClick);
  }

  onInputFocus() {
    addClass(this.el, "expanded");
  }

  onInputBlur() {
    removeClass(this.el, "expanded");
  }

  onButtonClick() {
    console.log("Search with :" + this.refs.input.value);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/SearchInput.js